import './Top.less';
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../uikit/UIKit';
import withUser from '../../withUser';
import HomeMessage from './HomeMessage';
import HelpButton from './help/HelpButton';
import Logo from '../components/Logo';
import { isEmpty, pathOr, propOr } from 'ramda';
import onSignOut from '../../lib/onSignOut';

const SignOutButton = ({ user }) => {
  if (isEmpty(propOr('', 'email', user))) {
    return null;
  }

  return <Button
    onClick={onSignOut}
    look="white"
  >
    Déconnexion
  </Button>;
};

const AdminButton = ({ user }) => {
  if (!pathOr(false, ['extra', 'isManager'])(user)) {
    return null;
  }

  return <Button
    to={'/admin/'}
    look="default"
  >
    Administration
  </Button>;
};

const Top = ({ user, withMessage = false, staticLayout }) => {
  if (staticLayout) {
    return <div className="layout-connection-top">
      <div className="layout-connection-top-wrapper">
        <div>
          <Logo className="layout-connection-top-logo"/>
        </div>
      </div>
    </div>;
  }

  return <div className="layout-connection-top">
    {withMessage && <HomeMessage/>}

    <div className="layout-connection-top-wrapper">
      <div>
        <Link to="/"><Logo className="layout-connection-top-logo"/></Link>
      </div>

      <div>
        <AdminButton user={user}/>
        <SignOutButton user={user} history={history}/>
      </div>
    </div>

    <HelpButton/>
  </div>;
};

export default withUser(Top);
